const AclModule = {
  CMMS: 'cmms',
  CSV: 'csv',
  DEFAULT: 'default',
  DOCUMENTS: 'documents',
  MONITORING: 'monitoring',
  TICKETING: 'ticketing',
  REPORTS: 'portfolio_reports',
  VIIU: 'viiu',
};

export default AclModule;
